import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vue from "vue";
import VueFlags from "@growthbunker/vueflags";

createApp(App).use(router,Vue,VueFlags).mount('#app')
